import { useCallback } from 'react';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { useSelector, useDispatch } from '../../context/Redux';
import { ownerIdSelector } from '../../redux/selectors/auth';
import OwnerSelect from '../filters/OwnerSelect';
import { setJitaPretendOwnerId } from '../../redux/actions/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function JitaUserArea() {
  const dispatch = useDispatch();
  const selectedOwnerId = useSelector(ownerIdSelector);
  const onChange = useCallback(event => {
    dispatch(setJitaPretendOwnerId({
      ownerId: event.target.value
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    "data-test-id": "jita-user-area",
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("b", {
        children: "JITA User Select"
      }), "\xA0", /*#__PURE__*/_jsx(UIHelpIcon, {
        title: "Select a user to view their queues and filters how they would see it."
      })]
    }),
    children: /*#__PURE__*/_jsx(OwnerSelect, {
      placeholder: "Select a User",
      value: selectedOwnerId === -1 ? undefined : selectedOwnerId,
      error: selectedOwnerId === -1,
      menuWidth: 300,
      onChange: onChange
    })
  });
}